import {ChangeDetectorRef, Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {ContentService} from "../../_services/content.service";
import {Community} from "../../_types/communities";
import {LocalStorageService} from "../../_services/local-storage.service";
import {AuthService} from "../../_services/auth.service";
import {User} from "../../_types/user";
import {PageEvent} from "@angular/material/paginator";
import {take} from "rxjs";
import {CommentsComponent} from "../comments/comments.component";

@Component({
    selector: 'app-posts-list',
    templateUrl: './posts-list.component.html',
    styleUrl: './posts-list.component.scss'
})
export class PostsListComponent {
    myPosts: boolean = false;
    comments: any[] = [];
    posts: any[] = [];
    communityId: number | undefined;
    user: User | null = null;

    commentsColumns: string[] = ['comment', 'created', 'likes', 'attachments', 'view'];
    commentsPage: number = 1;
    commentsLimit: number = 15;
    commentsCount: number = 0;

    postsColumns: string[] = ['name', 'created', 'likes', 'comments', 'view'];
    postsPage: number = 1;
    postsLimit: number = 15;
    postsCount: number = 0;

    postsfilters: any;

    constructor(@Inject(MAT_DIALOG_DATA) private data: { myPosts?: boolean },
                private contentService: ContentService,
                private localStorageService: LocalStorageService,
                private authService: AuthService,
                public dialog: MatDialog,
                public changeDetection: ChangeDetectorRef) {
        this.communityId = this.localStorageService.getItem<Community | null>('lastSelectedCommunity', null)?.id
        this.user = this.authService.getUser();
        this.postsfilters = {community: this.communityId}

        if (data?.myPosts) {
            this.myPosts = data.myPosts;
            this.getPosts()
            this.getComments();
        } else {
            this.getPosts()
            this.postsColumns = ['name', 'author', 'created', 'likes', 'comments', 'view'];
        }
    }

    getPosts(): void {
        if (this.myPosts) {
            this.contentService.getPosts(this.postsPage, this.postsLimit, this.postsfilters).subscribe(r => {
                this.postsCount = r.count;
                this.posts = r.results;
            }, e => {
                console.error(e)
            })
        } else {
            this.contentService.getFeed(this.communityId || 0, this.postsPage, this.postsLimit).subscribe(r => {
                this.postsCount = r.count;
                this.posts = r.results;
            }, e => {
                console.error(e)
            })
        }
    }

    viewPost(post: any): void {
        this.contentService.getPostById(post.id).pipe(take(1))
            .subscribe(post => {
                this.contentService.getPostComments(post.id).pipe(take(1)).subscribe((comments): void => {
                    this.changeDetection.detach();
                    //open modal
                    const dialogRef: MatDialogRef<CommentsComponent> = this.dialog.open(CommentsComponent, {
                        data: {
                            comments: comments,
                            post,
                        },
                        autoFocus: false,
                        panelClass: ['mediumWindow', 'w-100', 'comments-modal'],
                    });
                    dialogRef.afterClosed().subscribe((): void => {
                        this.changeDetection.reattach();
                    });
                });
            });
    }

    handlePostPageEvent(e: PageEvent): void {
        this.postsPage = e.pageIndex + 1;
        this.postsLimit = e.pageSize;
        this.getPosts();
    }

    getComments(): void {
        this.contentService.getAllComments(this.commentsPage, this.commentsLimit, this.communityId, this.user?.id).subscribe(r => {
            this.commentsCount = r.count;
            this.comments = r.results;
        }, e => {
            console.error(e)
        })
    }

    viewComment(comment: any): void {
        this.contentService.getPostById(comment.post).pipe(take(1))
            .subscribe(post => {
                this.contentService.getPostComments(post.id).pipe(take(1)).subscribe((comments): void => {
                    this.changeDetection.detach();
                    const dialogRef: MatDialogRef<CommentsComponent> = this.dialog.open(CommentsComponent, {
                        data: {
                            comments: comments,
                            post,
                            commentForScroll: comment.id
                        },
                        autoFocus: false,
                        panelClass: ['mediumWindow', 'w-100', 'comments-modal'],
                    });
                    dialogRef.afterClosed().subscribe((): void => {
                        this.changeDetection.reattach();
                    });
                });
            });
    }

    handleCommentsPageEvent(e: PageEvent): void {
        this.commentsPage = e.pageIndex + 1;
        this.commentsLimit = e.pageSize;
        this.getComments();
    }
}
